import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const AppTheme = definePreset(Aura, {
});

export default {
  preset: AppTheme,
  options: {
    darkModeSelector: '.p-dark'
  }
};
